import {PriceContext} from "../context/PriceContext";
import React, {useContext} from "react";
import {useLanguage} from "../context/LanguageContext";

const Price = () => {
    const priceContext = useContext(PriceContext);
    const {t} = useLanguage();

    if (priceContext.isPriceLoading) {
        return (
            <div>
                <div style={{height: '58px'}} className="h3">{t('price.calculating')}</div>
            </div>
        );
    }

    return (
        <div>
            <div className="h3">{t('price.gross')} {priceContext.priceGross.toFixed(2)} {t('common.currency')}</div>
            <div  className="h3">{t('price.net')} {priceContext.priceNett.toFixed(2)} {t('common.currency')}</div>
        </div>
    );
};
export default Price;
